import { Injectable } from '@angular/core';
import * as pbi from 'powerbi-client';

@Injectable({
  providedIn: 'root'
})
export class PowerBIService {
  private powerbi: pbi.service.Service;

  constructor() {
    this.powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
  }

  embedReport(embedConfig: pbi.models.IReportEmbedConfiguration, container: HTMLElement) {
    return this.powerbi.embed(container, embedConfig);
  }

  reset(container: HTMLElement) {
    this.powerbi.reset(container);
  }
}
